<template>
    <b-modal id="gear-modal" hide-footer hide-header :title="title" header-text-variant="success">
        <div class="text-center">
            <h3 class="text-success">Problème #{{ gearProblem.publicID }}</h3>
        </div>
        <ul>
            <li><strong>Niveau</strong> : {{ gearProblem.level}}</li>
            <li><strong>Catégorie</strong>  : {{ categoryName[this.gearProblem.category] }}</li>
            <li><strong>Domaine</strong> : {{ domainName[this.gearProblem.domain] }}</li>
            <li><strong>Complexité</strong> : {{ complexityName[this.gearProblem.complexity] }}</li>
            <li v-if="typology"><strong>Typologie</strong> : {{ typology }}</li>
        </ul>
    </b-modal>
</template>

<script>
export default {
  name: 'GearModal',
  props: {
      gearProblem: Object
  },
  data() {
      return {
        categoryName: {
            ADD: 'Additif',
            MUL: 'Multiplicatif',
            DIV: 'Division/Partage',
            PROP: 'Proportionnalité',
            NUM: 'Autre'
        },
        domainName: {
            INT: 'Entiers',
            DEC: 'Décimaux',
            FRAC: 'Fractions',
            GEO: 'Géométrie',
            LOGOS: 'Logique'
        },
        complexityName: {
            one: 'Une étape',
            more: 'Plus d\'une étape',
            atypique: 'Atypique' 
        },
      }
  },
  computed: {
      title() {
          return `Problème ${this.gearProblem.publicID}`
      },
      typology() {
          let typo = ''
          if (this.gearProblem.category == 'ADD') {
              if(this.gearProblem.typoAdd == 'trans') { typo = 'Transformation' }
              if(this.gearProblem.typoAdd == 'compos') { typo = 'Composition' }
              if(this.gearProblem.typoAdd == 'compar') { typo = 'Comparaison' }
              if(this.gearProblem.typoAdd == 'compos-de-trans') { typo = 'Composition de transformations' }
          }
          if (this.gearProblem.category == 'MUL') {
              if(this.gearProblem.typoMul == 'rect') { typo = 'Rectangulaire' }
              if(this.gearProblem.typoMul == 'cartesian') { typo = 'Produit cartésien' }
              if(this.gearProblem.typoMul == 'n-times') { typo = 'n fois plus/moins' }
          }
          if (this.gearProblem.category == 'DIV') {
              if(this.gearProblem.typoDiv == 'partition') { typo = 'Partition' }
              if(this.gearProblem.typoDiv == 'quotition') { typo = 'Quotition' }
          }
          return typo
      }
  }
}
</script>